export default __webpack_public_path__ + "static/media/webby-trophy-breathing.174073af.gif";